import { apiService } from '../APIService';
import { CRUDFactory } from '../CRUDFactory';

/**
 *  Чат с клиентом
*/
export const CRUDChat = CRUDFactory('chats');

export default {
  changeUser(id, params) {
    return apiService.post(`/chats/${id}/change-user`, params);
  },
};
